import {Calendar} from "vanilla-calendar-pro";

export default class AvailableDatesManager {
    constructor() {
        this.listeners = [];
        this.datesCalendarContainer = document.querySelector('#dates-calendar');
        this.numDays = 0;
        this.enabledDates = [];
        this.cholloId = document.querySelector('[name="id_chollo"]')?.value;
        this.lastCurrentDateSelected = null;
        this.eventDelegation();
    }

    eventDelegation() {
        let modal = document.querySelector('#dates_modal');
        if (!modal) {
            return;
        }
        modal.addEventListener('custom-modal-show', () => {
            let calendarElement = document.querySelector('#dates-calendar');
            modal.querySelector('[data-entity="dates-modal"]').append(calendarElement);
        });

        modal.addEventListener('custom-modal-hide', () => {
            let calendarElement = document.querySelector('#dates-calendar');
            document.querySelector('[data-container="dates-calendar"]').append(calendarElement);
        });
    }

    initializeCalendar(data) {
        if (!data || !data.dates || !data.dates.shown_months) {
            return
        }
        this.data = data;
        if (this.calendar) {
            this._cleanListeners();
            this.calendar.update(this._getCalendarOptions(data.dates.shown_months))
        } else {
            let options = {
                selectionDatesMode: 'single',
                locale: myApp.config.locale,
                selectedTheme: 'light',
                disableAllDates: true,
                displayDatesOutside: false,
                onCreateDateEls: this._onCreateDateEls.bind(this),
                onClickDate: this._onClickDate.bind(this),
                disableDatesPast: true,
                selectionMonthsMode: false,
                selectionYearsMode: false,
            };
            options = {...options, ...this._getCalendarOptions(data.dates.shown_months)};
            this.calendar = new Calendar('#dates-calendar', options);
            this.calendar.init();
        }
    }

    _cleanListeners() {
        this.listeners.forEach(({element, type, handler}) => {
            element.removeEventListener(type, handler);
        });
        this.listeners = [];
    }

    _onClickDate(calendar, event) {
        let currentSelectedDate = calendar.context.selectedDates[0];
        this._setSelectedDates(calendar, currentSelectedDate);
    }

    _setSelectedDates(calendar, currentSelectedDate) {
        document.querySelectorAll('.calendar-day-selected').forEach(element => {
            element.classList.remove('calendar-day-selected');
        })

        document.querySelectorAll('.calendar-day-selected-end').forEach(element => {
            element.classList.remove('calendar-day-selected-end');
        });

        if (!currentSelectedDate) {
            return;
        }

        let startDate = new Date(currentSelectedDate);
        let endDate = new Date(currentSelectedDate);
        endDate.setDate(endDate.getDate() + this.numDays);

        let rangeEnabledDates = this._createRangeEnabledDates(startDate, endDate);
        rangeEnabledDates.forEach(date => {
            let dateElements = document.querySelectorAll('[data-vc-date="' + date + '"]');
            dateElements.forEach(dateElement => {
                dateElement.classList.add('calendar-day-selected');
                if (date == rangeEnabledDates[rangeEnabledDates.length - 1]) {
                    dateElement.classList.add('calendar-day-selected-end');
                }
            });
        });
        this.lastCurrentDateSelected = currentSelectedDate;
        myApp.bookingConfigurator.setDate(startDate, endDate);
    }

    _createRangeEnabledDates(startDate, endDate) {
        startDate = new Date(startDate);
        endDate = new Date(endDate);
        startDate.setDate(startDate.getDate() + 1);
        if (startDate > endDate) {
            return [];
        }
        let dateArray = [];
        while (startDate <= endDate) {
            dateArray.push(startDate.toISOString().split('T')[0]);
            startDate.setDate(startDate.getDate() + 1);
        }
        return dateArray;
    }

    _onCreateDateEls(calendar, dateEl) {
        let currentDate = dateEl.dataset.vcDate;
        Object.values(this.data.dates.shown_months).forEach(month => {
            const matchingDate = Object.values(month.dates).find(date => date.inicio == currentDate);
            let dateBtn = dateEl.querySelector('[data-vc-date-btn]');
            if (!dateBtn) {
                return;
            }
            let element = null;
            if (matchingDate && typeof matchingDate == 'object') {
                if (matchingDate.precio) {
                    element = this._createCalendarPriceElement(matchingDate, dateEl);
                } else if (matchingDate.availabilityAlert) {
                    element = this._createAvailabilityAlertElement(matchingDate, dateEl)
                } else {
                    element = this._createMinimumStayElement(matchingDate, dateEl, currentDate);
                }
            }
            if (element) {
                dateBtn.innerHTML += element;
            }
        });
    }

    _createCalendarPriceElement(matchingDate, dateEl) {
        dateEl.classList.add('calendar-day-price');
        let element = ('<div class="calendar-day-extra-data">' + matchingDate.precio + ' €</div>');
        if (!this.numDays) {
            let endDate = new Date(matchingDate.fin + 'T00:00:00');
            let startDate = new Date(matchingDate.inicio + 'T00:00:00');
            let difference = endDate.getTime() - startDate.getTime();
            this.numDays = Math.round(difference / (1000 * 3600 * 24));
        }
        return element;
    }

    _createAvailabilityAlertElement(matchingDate, dateEl) {
        dateEl.classList.add('calendar-day-no-available');
        let element = "<i class='ci ci-bell-fill ci-s-15 calendar-day-extra-data color-secondary'></i>";
        let functionTmp = this._onAvailabilityAlert.bind(this, matchingDate);
        dateEl.addEventListener('click', functionTmp);
        this.listeners.push({
            element: dateEl,
            type: 'click',
            handler: functionTmp
        })
        return element;
    }

    _createMinimumStayElement(matchingDate, dateEl, currentDate) {
        dateEl.classList.add('calendar-day-no-available');
        let element = "<i class='ci ci-info ci-s-15 calendar-day-reminder calendar-day-extra-data'></i>";
        let functionTmp = this._onMinimumStayDateSelected.bind(this, matchingDate, currentDate);
        dateEl.addEventListener('click', functionTmp);
        this.listeners.push({
            element: dateEl,
            type: 'click',
            handler: functionTmp
        })
        return element;
    }

    _onAvailabilityAlert(matchingDate) {
        if (myApp.config.isUserLoggedIn) {
            let startDate = new Date(matchingDate.inicio);
            let startDateNum = startDate.getDate();
            let startDateDay = startDate.toLocaleString(myApp.config.locale, {weekday: 'long'});
            let startDateMonth = startDate.toLocaleString(myApp.config.locale, {month: 'long'});

            let endDate = new Date(matchingDate.fin);
            let endDateNum = endDate.getDate();
            let endDateDay = endDate.toLocaleString(myApp.config.locale, {weekday: 'long'});
            let endDateMonth = endDate.toLocaleString(myApp.config.locale, {month: 'long'});

            myApp.bookingConfigurator.showAvailabilityAlert(matchingDate.id, startDateNum, startDateDay, startDateMonth, endDateNum, endDateDay, endDateMonth);
        } else {
            myApp.user.loginManager.openLoginModal();
            myApp.customModalManager.openModal('#userModal');
        }
    }

    _onMinimumStayDateSelected(matchingDate, currentDate) {
        if (!this.cholloId) {
            return;
        }
        myApp.bookingConfigurator.selectMininumStayDate(
            matchingDate.suggestedCategoryText ?? '',
            matchingDate.suggestedCholloText ?? '',
            matchingDate.nights,
            this.cholloId,
            matchingDate.idChollo,
            matchingDate.tagChollo,
            currentDate
        );
    }

    _getCalendarOptions(months) {
        let dateMin, dateMax;

        Object.values(months).forEach(month => {
            Object.values(month.dates).forEach(date => {
                if (date.min_stay || !date.inicio || !date.precio) {
                    return;
                }
                this.enabledDates.push(date.inicio);
                if (date.inicio < dateMin || !dateMin) {
                    dateMin = date.inicio;
                }
                if (date.fin > dateMax || !dateMax) {
                    dateMax = date.fin;
                }
            });
        });
        const startDate = new Date(dateMin);
        const endDate = new Date(dateMax);
        const yearsDifference = endDate.getFullYear() - startDate.getFullYear();
        const monthsDifference = endDate.getMonth() - startDate.getMonth();
        let displayMonthsCount = yearsDifference * 12 + monthsDifference + 1;
        let type = displayMonthsCount < 2 ? 'default' : 'multiple';
        return {
            dateMin: dateMin,
            dateMax: dateMax,
            displayDateMin: dateMin,
            displayDateMax: dateMax,
            enableDates: this.enabledDates,
            displayMonthsCount: displayMonthsCount,
            type: type,
        }
    }
}
